import { ReactComponent as BurgerMenu } from '@assets/svg/burger.svg';
import { ReactComponent as Logo } from '@assets/svg/logo.svg';
import LinkBar from '@components/Navbar/components/linkbar.components';
import TabBar from '@components/Navbar/components/tabbar.components';
import UserWidget from '@components/Navbar/components/userWidget.components';
import { User } from '@features/login/store/state';
import { TranslatorManager } from '@managers/TranslatorManager';
import { NavigationManager } from '@managers/navigation.manager';
import './styles/navbar.style.scss';
import React from 'react';
import { ReduxConnect } from '@hypereact/state';
import { RootState } from '@store/state';
import _ from 'lodash';

export interface INavBarProps {
    isLogged?: boolean;
    user?: User;
    isIDEOpen?: boolean;
    currentRoute?: string;
}

// export interface INavBarState {
//     currentRoute: string;
// }

@ReduxConnect((state: RootState) => {
    return {
        isIDEOpen: state.project.project.isIDEOpen,
        currentRoute: state.shared.currentRoute,
    };
})
class NavBar extends React.Component<INavBarProps> {
    private translator: TranslatorManager;
    private navigator: NavigationManager;

    constructor(props: INavBarProps) {
        super(props);
        this.translator = TranslatorManager.getInstance();
        this.navigator = NavigationManager.getInstance();
        this.handleRouteChange = this.handleRouteChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            currentRoute: this.navigator.getCurrentRoute(),
        });
    }

    handleRouteChange(route: string) {
        this.setState({
            currentRoute: route,
        });
    }

    render() {
        return (
            <>
                <nav className='navbar navbar-expand-lg bg-white navbar-container p-0'>
                    <div className='container-fluid'>
                        <a
                            className='navbar-brand logo d-flex justify-content-center'
                            onClick={() => {
                                this.handleRouteChange('/home');
                                NavigationManager.getInstance().navigateTo('/home');
                            }}>
                            <Logo />
                        </a>
                        {<TabBar onRouteChange={this.handleRouteChange} />}
                        <button
                            className='navbar-toggler btn shadow-none'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#navbarNav'
                            aria-controls='navbarNav'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                            data-focus-mouse='false'>
                            <BurgerMenu fill='#009102' />
                        </button>
                        <div className='collapse navbar-collapse ' id='navbarNav'>
                            <ul className='navbar-nav '>
                                <li className='nav-item d-flex align-items-center'>
                                    <div className='nav-link'>
                                        <LinkBar isIDEOpen={this.props.isIDEOpen as boolean} route={this.props.currentRoute as string} />
                                    </div>
                                </li>
                                <li className='nav-item d-none d-lg-flex justify-content-center'>
                                    {this.props.isLogged && <div className='vr' />}
                                    <div className='nav-link d-flex align-items-center'>
                                        <UserWidget user={this.props.user} />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </>
        );
    }
}

export default NavBar;
